<form #countryForm="ngForm" class="row">
	<mat-form-field class="col">
		<mat-label>{{ label }}</mat-label>
		<input matInput aria-label="Country" type="text" [placeholder]="placeholder" [id]="id" [name]="name"
			[matAutocomplete]="auto" [(ngModel)]="selectedCountry.COUNTRY_NAME" #searchString="ngModel"
			#searchStringInput [value]="selectedCountry.COUNTRY_NAME" [required]="required"
			(ngModelChange)="checkForId(searchString)" [readonly]="disabledCountry" [disabled]="disabled" />
		<button mat-icon-button matSuffix [attr.aria-label]="'Country Valid'"
			[color]="selectedCountry && selectedCountry.ID ? 'primary' : 'warn'" tabindex="-1" [disabled]="disabled">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && (countryForm.dirty || selectedCountry.ID! > 0)">
				{{ selectedCountry.ID ? "done" : "close" }}
			</mat-icon>
		</button>
	</mat-form-field>
	<app-msg *ngIf="!isLoading" class="msg-position"
		[msg]="{MSG:searchString.errors?.['idRequired'], SUCCESS:!searchString.errors?.['idRequired']}"></app-msg>
	
	<app-msg *ngIf="displayRequiredMessage && !isLoading && !searchString.errors?.['idRequired']" class="msg-position"
		[msg]="requiredMsg"></app-msg>

	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
		<ng-container *ngIf="!isLoading">
			<mat-option *ngFor="let country of countries" [value]="country">
				{{country.COUNTRY_NAME}}
			</mat-option>
		</ng-container>
	</mat-autocomplete>
</form>